import { render } from "./AddTarificationPage.vue?vue&type=template&id=569b030a&ts=true"
import script from "./AddTarificationPage.vue?vue&type=script&lang=ts"
export * from "./AddTarificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__